var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "分享配置", name: "TicketShareConfig" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "TicketShareConfig"
                    ? _c("TicketShareConfig")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "分享记录", name: "TicketShareRecord" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "TicketShareRecord"
                    ? _c("TicketShareRecord")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "领取记录", name: "TicketAcceptRecord" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName == "TicketAcceptRecord"
                    ? _c("TicketAcceptRecord")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }